import api from '../api';

const notesService = {
    // Get notes for a specific property
    getPropertyNotes: async (propertyId) => {
        try {
            const response = await api.get(`/notes/properties/${propertyId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching property notes:', error);
            throw error;
        }
    },

    // Add note to property
    addNoteToProperty: async (propertyId, noteData) => {
        try {
            const response = await api.post(`/notes/properties/${propertyId}`, noteData);
            return response.data;
        } catch (error) {
            console.error('Error adding note to property:', error);
            throw error;
        }
    },

    // Update a note
    updateNote: async (noteId, noteData) => {
        try {
            const response = await api.put(`/notes/${noteId}`, noteData);
            return response.data;
        } catch (error) {
            console.error('Error updating note:', error);
            throw error;
        }
    },

    // Delete a note
    deleteNote: async (noteId) => {
        try {
            const response = await api.delete(`/notes/${noteId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting note:', error);
            throw error;
        }
    },

    // Get all notes (existing functionality)
    getAll: async () => {
        try {
            const response = await api.get('/notes');
            return response.data;
        } catch (error) {
            console.error('Error fetching all notes:', error);
            throw error;
        }
    },

    // Get notes by parameters (existing functionality)
    getByParam: async (params) => {
        try {
            const response = await api.get('/notes/getByParam', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching notes by param:', error);
            throw error;
        }
    },

    // Create note (existing functionality)
    create: async (noteData) => {
        try {
            const response = await api.post('/notes', noteData);
            return response.data;
        } catch (error) {
            console.error('Error creating note:', error);
            throw error;
        }
    },

    // Update note by parameters (existing functionality)
    updateByParam: async (params, noteData) => {
        try {
            const response = await api.put('/notes', noteData, { params });
            return response.data;
        } catch (error) {
            console.error('Error updating note by param:', error);
            throw error;
        }
    },

    // Delete note by parameters (existing functionality)
    deleteByParam: async (params) => {
        try {
            const response = await api.delete('/notes', { params });
            return response.data;
        } catch (error) {
            console.error('Error deleting note by param:', error);
            throw error;
        }
    },
};

export default notesService; 